/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'web-ui-components/lib/layout/grids';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { AccountPaymentTable } from 'web-ui-components/lib/finance/accounts';
import withContent from '../../../containers/withContent';
import paymentDetailsContent, { contentPropTypes } from './BatchPaymentDetails.content';
import { formatAccountDetails } from '../../../utils/accountUtils';
import { verificationPropTypes } from '../../../states/payments/propTypes';
import { formatAmount } from '../../../utils/numberUtils';
import { showAccountDetails, showAmount, getFormattedReference } from '../../../utils/paymentsUtils';

const BatchInformationPaymentTable = ({ content, payments, isFileUpload }) => {
	const { fromLabel, toLabel, amountLabel, refLabel } = content;

	const batchHeader = [
		{ type: 'account', label: fromLabel },
		{ type: 'account', label: toLabel },
		{ type: 'currency', label: amountLabel },
		{ type: 'iban', label: refLabel },
	];

	const getMyDataForFileUpload = (payments) =>
		payments.map((payment, index) => [
			showAccountDetails(payment.from_account, index),
			showAccountDetails(payment.to_account, index),
			showAmount(payment.amount, index),
			getFormattedReference(payment.reference, index),
		]);

	const rows = [].concat(...getMyDataForFileUpload(payments));

	if (isFileUpload) {
		return <AccountPaymentTable headerData={batchHeader} tableData={rows} />;
	}
	return (
		<Grid.TwoThirds>
			{payments.map((batchPayment, idx) => (
				<div key={idx} className="u-margin-y-1">
					<VerticalReviewTable
						data={[
							{ headerText: toLabel, cellText: formatAccountDetails(batchPayment.to_account) },
							{ headerText: amountLabel, cellText: formatAmount(batchPayment.amount) },
							{ headerText: refLabel, cellText: batchPayment.reference },
						]}
					/>
				</div>
			))}
		</Grid.TwoThirds>
	);
};

BatchInformationPaymentTable.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	payments: PropTypes.arrayOf(PropTypes.shape({ verificationPropTypes })),
	isFileUpload: PropTypes.bool,
};

export const IndividualBatchPaymentInformation = withContent({ content: paymentDetailsContent })(
	BatchInformationPaymentTable
);
